module.exports = __webpack_public_path__ + "img/case05.1416a141.png";